module.exports = __webpack_public_path__ + "static/imgs/drugRecall.fd78187.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/drugRecall.jpg
// module id = gD1D
// module chunks = 1